import { Chip, Group, Input, Stack } from "@mantine/core";

interface ChipOption {
  value: string;
  label: string;
}

interface ChipSelectProps {
  label?: string;
  description?: string;
  options: ChipOption[];
  value?: string | null;
  onChange: (value: string) => void;
  required?: boolean;
  error?: React.ReactNode;
  orientation?: "horizontal" | "vertical";
  size?: "xs" | "sm" | "md";
}

export function ChipSelect({
  label,
  description,
  options,
  value,
  onChange,
  required,
  error,
  orientation = "horizontal",
  size = "sm",
}: ChipSelectProps) {
  const Wrapper = orientation === "vertical" ? Stack : Group;

  return (
    <Input.Wrapper
      label={label}
      description={description}
      required={required}
      error={error}
    >
      <Chip.Group value={value ?? undefined} onChange={(v) => onChange(v as string)}>
        <Wrapper gap="xs" mt={4}>
          {options.map((opt) => (
            <Chip key={opt.value} value={opt.value} size={size} variant="outline">
              {opt.label}
            </Chip>
          ))}
        </Wrapper>
      </Chip.Group>
    </Input.Wrapper>
  );
}
